export default __webpack_public_path__ + "static/product3-5f6a0e1ef3653b226adc8c7f174854a2.png";